export default "__VITE_ASSET__DXvmhm_o__"